import { createSwiperProductBlocks } from './base'
import { handleFreeShipping } from './global'

export function initAdvancedOrder() {
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
        updateButtonText()
        handleFreeShipping()
        addContinueShoppingButton()

        setTimeout(() => {
            createSwiperProductBlocks('.advanced-order .products-wrapper')
            $('.advanced-order .swiper-products-container').show()
        }, 200)
    })
}

function updateButtonText() {
    $('.advanced-order .extra.step .btn').text('Do košíku')
}

function addContinueShoppingButton() {
    $('.advanced-order .extra.step').prepend(
        '<button class="btn continue-shopping">Pokračovat v nákupu</button>'
    )

    $('.continue-shopping').on('click', () => {
        shoptet.modal.close()
    })
}
